import * as EducationExternals from './externals';

export const ReducerKeys = Object.freeze({
  LISTENERS: EducationExternals.ReducerKeys.LISTENERS,
  MTUP_PLAYLIST_READY_FOR_MINICOACHMARK: 'MTUP_PLAYLIST_READY_FOR_MINICOACHMARK',
  PODCAST_POSITIVE_FEEDBACK_COUNT: 'podcastPositiveFeedbackCount',
  PREMIUM_ACCESS_EDUCATION_EXIT_MESSAGE_COUNT: 'premiumAccessEducationExitMessageCount',
  PREMIUM_ACCESS_EDUCATION_WELCOME_MESSAGE_COUNT: 'premiumAccessEducationWelcomeMessageCount',
  SHOW_COUNT: EducationExternals.ReducerKeys.SHOW_COUNT,
  WATCH_FOR_MTUP_PLAYLIST_UNLOCK: 'WATCH_FOR_MTUP_PLAYLIST_UNLOCK',
} as const);

export const ActionKeys = Object.freeze({
  INCREMENT_PREMIUM_ACCESS_EDUCATION_WELCOME_MESSAGE_COUNT:
    'INCREMENT_PREMIUM_ACCESS_EDUCATION_WELCOME_MESSAGE_COUNT',
  INCREMENT_PREMIUM_ACCESS_EDUCATION_EXIT_MESSAGE_COUNT:
    'INCREMENT_PREMIUM_ACCESS_EDUCATION_EXIT_MESSAGE_COUNT',
  UPDATE_WATCH_FOR_MTUP_UNLOCK: 'UPDATE_WATCH_FOR_MTUP_UNLOCK',
  UPDATE_MTUP_PLAYLIST_READY_FOR_MINICOACHMARK: 'UPDATE_MTUP_PLAYLIST_READY_FOR_MINICOACHMARK',
} as const);

// todo WEBCLIENT-9692
export const PremiumAccessEducationConstants = Object.freeze({
  PREMIUM_ACCESS_FTUX_EXIT_MESSAGE_URL:
    'https://pandora.com/static/creatives/valueExchange/FTUX/audio/Pandora_PAFTUX_IACS-1700_Script2_V2.mp3',
  PREMIUM_ACCESS_EDUCATION_EXIT_MESSAGE_LIMIT: 1,
} as const);

export const AntiAdBlockerEducationConstants = Object.freeze({
  HAMMER_MODE: 'https://pandora.com/static/creatives/Blocker/Anti-Blocker-Hammer.mp3',
} as const);

export const SourceTypeConstants = Object.freeze({
  FTUX_WELCOME_TONE: 'ftux_welcome_tone',
  FTUX_WELCOME_MESSAGE: 'ftux_welcome_message',
} as const);

export const MAX_PODCAST_POSITIVE_FEEDBACK_COUNT =
  EducationExternals.MAX_PODCAST_POSITIVE_FEEDBACK_COUNT;
